(() => {
  const canvas = document.getElementById("snow-canvas");
  if (!canvas) return;

  const ctx = canvas.getContext("2d");
  let w, h;

  function resize() {
    w = canvas.width = window.innerWidth;
    h = canvas.height = window.innerHeight;
  }

  resize();
  window.addEventListener("resize", resize, { passive: true });

  const flakes = [];
  const FLAKE_COUNT = window.innerWidth < 768 ? 36 : 160;

  class Snowflake {
    constructor(layer) {
      this.layer = layer;
      this.reset(true);
    }

    reset(initial = false) {
      this.x = Math.random() * w;
      this.y = initial ? Math.random() * h : -10;

      // depth layers (UNCHANGED)
      if (this.layer === 0) {
        this.radius = Math.random() * 2.8 + 1.5;
        this.speed = Math.random() * 0.6 + 0.6;
        this.opacity = Math.random() * 0.4 + 0.2;
      } else if (this.layer === 1) {
        this.radius = Math.random() * 2.8 + 1.56;
        this.speed = Math.random() * 0.9 + 0.8;
        this.opacity = Math.random() * 0.4 + 0.4;
      } else {
        this.radius = Math.random() * 2.8 + 1.6;
        this.speed = Math.random() * 1.2 + 1;
        this.opacity = Math.random() * 0.4 + 0.6;
      }

      // cache fill style (VISUALLY IDENTICAL)
      this.fill = `rgba(255,255,255,${this.opacity})`;

      this.angle = Math.random() * Math.PI * 2;
      this.drift = Math.random() * 0.6 + 0.2;
    }

    update() {
      this.angle += 0.01 * this.drift;
      this.x += Math.sin(this.angle) * this.drift;
      this.y += this.speed;

      if (this.y > h + 10) {
        this.reset();
      }
    }

    draw() {
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
      ctx.fillStyle = this.fill;
      ctx.fill();
    }
  }

  // Create layered snow (UNCHANGED)
  for (let i = 0; i < FLAKE_COUNT; i++) {
    flakes.push(new Snowflake(i % 3));
  }

  /* ------------------------------
     Animation optimisation
  ------------------------------ */

  let running = true;
  let scrolling = false;

  document.addEventListener("visibilitychange", () => {
    running = !document.hidden;
  });

  window.addEventListener("scroll", () => {
    scrolling = true;
    clearTimeout(window.__snowScrollTimer);
    window.__snowScrollTimer = setTimeout(() => {
      scrolling = false;
    }, 150);
  }, { passive: true });

  let lastTime = 0;
  const FPS = 60;
  const FRAME = 1000 / FPS;

  function animate(time) {
    if (!running || scrolling || time - lastTime < FRAME) {
      requestAnimationFrame(animate);
      return;
    }

    lastTime = time;
    ctx.clearRect(0, 0, w, h);

    // faster loop, same result
    for (let i = 0; i < flakes.length; i++) {
      flakes[i].update();
      flakes[i].draw();
    }

    requestAnimationFrame(animate);
  }

  requestAnimationFrame(animate);
})();